<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            name="search"
            type="year"
            label="교육년도"
            v-model="searchParam.educationYear"
          ></c-datepicker>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="none"
            :comboItems="kindItems"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="교육종류1"
            v-model="searchParam.educationKindCdLarge"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="EDU_KIND_SEC_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdSmall"
            label="교육종류2"
            v-model="searchParam.educationKindCdSmall"
          ></c-select>
        </div>
        <!-- <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="EDU_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="educationTypeCd"
            label="교육구분"
            v-model="searchParam.educationTypeCd"
          ></c-select>
        </div> -->
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="연간 교육 일정 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :filtering="false"
      :checkClickFlag="false"
      :isExcelDown="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'annual-education-plan',
  props: {
    eduInfo: {
      type: Object,
      default(){
        return {
          educationKindCdLarge: '',
        }
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
      },
      searchParam: {
        plantCd: null,
        educationYear: '',
        educationKindCdSmall: null,
        educationKindCdLarge: null,
        educationTypeCd: null,
        legalEduYn: null,
      },
      kindItems: [],
      searchYear: '',
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.edu.annual.list.url;
      // code setting
      this.$comm.getComboItems('EDU_KIND_FST_CD').then(_result => {
        let attrVal1 = this.eduInfo.educationKindCdLarge == 'EKFC000001' ? 'SAF' : 'ENV'
        _result = this.$_.filter(_result, { attrVal1 : attrVal1 });
        _result.splice(0, 0, {
          codeName: '전체',
          code: attrVal1,
        })
        this.$set(this.$data, 'kindItems', _result)
      });
      this.searchParam.educationKindCdLarge = this.eduInfo.educationKindCdLarge;
      this.searchParam.educationYear = this.$comm.getThisYear();
      // list setting
      this.setHeader();
      this.getList();
    },
    getList() {
      if (!this.searchParam.educationYear) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '교육년도를 선택하세요.', // 교육년도를 선택하세요.
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      this.searchYear = this.$_.clone(this.searchParam.educationYear);
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    setHeader() {
      let yearmonth = []
      for(let i = 1; i <= 12; i++) {
        let month = this.$_.padStart(String(i), 2, '0');
        yearmonth.push({
          name: 'mon' + month,
          field: 'mon' + month,
          label: i + '월',
          align: 'center',
          sortable: false,
          child: [
            {
              name: 'monplan' + month,
              field: 'monplan' + month,
              label: '계획',
              align: 'center',
              style: 'width:40px', 
              sortable: false,
              type: "link",
            },
            {
              name: 'monresult' + month,
              field: 'monresult' + month,
              label: '결과',
              align: 'center',
              style: 'width:40px', 
              sortable: false,
              type: "link",
            },
          ]
        })
      }
      this.grid.columns = [
          {
          name: "plantName",
          field: "plantName",
          label: "사업장",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          name: "educationCourseName",
          field: "educationCourseName",
          label: "교육과정",
          align: "left",
          style: 'width:200px',
          sortable: true,
          type: "link",
        },
        {
          name: "educationKindCdLargeName",
          field: "educationKindCdLargeName",
          label: "교육종류1",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          name: "educationKindCdSmallName",
          field: "educationKindCdSmallName",
          label: "교육종류2",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        // {
        //   name: "educationTypeNames",
        //   field: "educationTypeNames",
        //   label: "교육구분",
        //   style: 'width:100px',
        //   align: "center",
        //   sortable: true,
        // },
        {
          label: '연간교육일정',
          align: 'center',
          sortable: false,
          child: yearmonth
        },
        {
          name: "relatedLawsName",
          field: "relatedLawsName",
          label: "관련법규",
          style: 'width:200px',
          align: "left",
          sortable: true,
        },
        {
          name: "departmentDeptNames",
          field: "departmentDeptNames",
          label: "주관부서",
          style: 'width:120px',
          align: "left",
          sortable: true,
        },
      ]
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.annualPopup(row, col, true);
    },
    annualPopup(result, col, flag) {
      let title = '';
      let param = null;

      if (col.name === 'educationCourseName') {
        this.popupOptions.target = () =>
          import(`${"./cc/educationCurriculumDetail.vue"}`);
          param = {
            eduCourseId: result.eduCourseId ? result.eduCourseId : '',
            educationKindCdLarge: this.searchParam.educationKindCdLarge,
          };
        this.popupOptions.isFull = true;
          title = '교육과정 마스터 상세';
      } else {
        this.popupOptions.target = () =>
          import(`${"./annualEducationPlanDetail.vue"}`);
          param = {
            educationKindCdLarge: result.educationKindCdLarge ? result.educationKindCdLarge : '',
            eduEducationId: result.eduEducationId ? result.eduEducationId : '',
            eduCourseId: result.eduCourseId ? result.eduCourseId : '',
            educationMonth: flag ? col.name.substring(col.name.length - 2) : '',
            educationYear: flag ? result.educationYear : '',
            plantCd: flag ? result.plantCd : '',
            disabled: true,
            /**
             * 2022-05-12 kdh
             * 교육, 결과/완료 구분자 param
             */
            stepFlag: col.name.indexOf('plan') > -1 ? 'N' : 'Y',
            // approvalStatusCd: this.yearEdu.approvalStatusCd
          };
        this.popupOptions.isFull = false;
        title = result.educationCourseName + '의 ' + this.searchYear + '년 ' +
        col.label + ' 연간교육계획 상세'
      }
      this.popupOptions.title = title;
      this.popupOptions.param = param;
      this.popupOptions.width = '95%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>